<template>
  <b-button variant="outline-danger" v-on:click="pressed">{{$t("DELETE")}}</b-button>
</template>
<script>
import { ajaxDelete } from "../../ajax";
import {apiUrl} from "@/main";

export default {
  props: ["TenantID", "token"],
  methods: {
    pressed: function(event) {
      event.preventDefault();

      ajaxDelete(
        apiUrl()+ "/tenants/" +
          parseInt(this.TenantID),
        this.deleteSuccess,
        this.dataError,
        this.token
      );
    },
    deleteSuccess: function() {
      this.$emit("removeTenant", this.TenantID);
    },
    dataError: function(status = 0) {
      if (status == 401) {
        this.$emit("logout");
        this.$router.push("/");
      }
    }
  }
};
</script>